import type { RouteLocationNormalized } from 'vue-router';
import { config } from '@/config';
import { createAuthProvider } from '@/integrations/Immersve/auth/createAuthProvider';
import { useAuthStore } from '@/stores/auth.store';

export async function beforeEachGuard(to: RouteLocationNormalized) {
  if (!to.meta.requiresAuth) {
    return;
  }

  try {
    createAuthProvider({
      authType: config.authType,
      apiKey: config.apiKey,
      apiSecret: config.apiSecret,
    });
  } catch {
    return { path: '/unauthorised', replace: true };
  }

  if (config.authType !== 'cookie') {
    return;
  }

  const authStore = useAuthStore();
  await authStore.initialize();
  if (authStore.status === 'unauthenticated') {
    return { path: '/auth/redirect', query: { returnTo: to.fullPath }, replace: true };
  }
}
